import React from 'react';

export const PogKranText = () => {
  return (
    <p>
      Установлюють біля входів, у вестибюлях, коридорах, проходах та в інших доступних місцях на висоті 1,35 м від
      підлоги. Можна розміщувати у стінній ніші з кришкою, у настінній шафі або у шафі в стінній ніші, які мають отвори
      для провітрювання, пристосовані для опломбування та візуального огляду крана без відчиннення.
    </p>
  );
};
